import { render, staticRenderFns } from "./radio-modal-default.mpx?vue&type=template&id=c6acaa3e&isComponent&outputPath=components%2Fradio-modal-default52146586%2Findex"
import script from "./radio-modal-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-default52146586%2Findex"
export * from "./radio-modal-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-default52146586%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports